import '../scss/customize.scss';
import Utility from "./utils/utility";
import App from "./app";
import HOME from "./pages/home";
import SHOP from "./pages/shop";
import EVENT from "./pages/event";
import RAKUICHI from "./pages/rakuichi";

// ユーティリティクラスのインスタンス化
const UTIL = new Utility();

// テンプレートインスタンス化（promise登録）
const TPL = new App();

// URLによる関数の実行
UTIL.loader( (request, path) => {
if ( path === '/' ) {
    HOME();
  } 
  // 「/shop/」から始まるすべてのパス（詳細ページ含む）にヒットさせる
  else if ( path.startsWith('/shop/') ) {
    SHOP();
  }
  else if ( path.startsWith('/event/') ) {
    EVENT();
  }
  else if ( path.startsWith('/rakuichi/') ) {
    RAKUICHI();
  }
});
// テンプレートインスタンスの初期化（イベント発火）
TPL.init();